export type PathComponent =
	| { type: "object"; key: string }
	| { type: "array"; index: number | "append" | { fromEnd: number } };

export function parseJsonPath(path: string): PathComponent[] {
	// Must start with exactly one '$'
	if (!path.startsWith("$") || path.startsWith("$$")) {
		throw new Error('JSON path must start with exactly one "$"');
	}

	const components: PathComponent[] = [];
	let pos = 1;

	while (pos < path.length) {
		if (path[pos] === ".") {
			// Object access: .objectlabel
			pos++;
			let key = "";
			while (pos < path.length && /[a-zA-Z0-9_]/.test(path[pos]!)) {
				key += path[pos];
				pos++;
			}
			if (!key) {
				throw new Error(`Empty key '${key}' in path`);
			}
			components.push({ type: "object", key });
		} else if (path[pos] === "[") {
			// Array access: [index] or [#-N] or [#]
			pos++;
			let indexStr = "";
			while (pos < path.length && path[pos] !== "]") {
				indexStr += path[pos];
				pos++;
			}
			if (path[pos] !== "]") {
				throw new Error("Unterminated array index");
			}
			pos++;

			if (indexStr === "#") {
				// Append position
				components.push({ type: "array", index: "append" });
			} else if (indexStr.startsWith("#-")) {
				// From end
				const n = parseInt(indexStr.slice(2));
				if (isNaN(n) || n < 0) {
					throw new Error("Invalid negative index");
				}
				components.push({ type: "array", index: { fromEnd: n } });
			} else {
				// Regular index
				const n = parseInt(indexStr);
				if (isNaN(n) || n < 0) {
					throw new Error("Invalid array index");
				}
				components.push({ type: "array", index: n });
			}
		} else {
			throw new Error(`Unexpected character in path: '${path[pos]}'`);
		}
	}

	return components;
}
